import * as Blockly from "blockly";

const originalRegister = Blockly.fieldRegistry.register.bind(Blockly.fieldRegistry);

// Some @blockly/* field plugins bundle their own private copy of another
// plugin as a runtime dependency (e.g. @blockly/field-colour depends on
// @blockly/field-grid-dropdown internally for its custom-colour picker).
// Under Vite's dev bundler that can produce two distinct class objects for
// the same field type, and Blockly.fieldRegistry.register() throws when a
// name is re-registered with a different class reference. Both copies are
// functionally identical, so keep whichever registered first instead of
// letting the duplicate crash module evaluation.
Blockly.fieldRegistry.register = (type, fieldClass) => {
  try {
    originalRegister(type, fieldClass);
  } catch (e) {
    if (!(e instanceof Error && /already registered/.test(e.message))) {
      throw e;
    }
  }
};
